import { addValue } from "../actions";

export const INITIAL_RULES = {
  'set_full_name': {
    valueName: 'ContactFullName',
    callback(dispatch, values) {
      if (typeof SK !== 'undefined'
        && values.filter(value => value.id === 'ContactFullName').length <= 0
      ) {
        const {first_name, last_name, middle_name} = SK.user();
        let value = `${last_name || ''} ${first_name || ''} ${middle_name || ''}`.trim();
        if (value && value.length > 0) {
          dispatch(addValue('ContactFullName', value, false));
        }
      }
    },
  },
  'set_phone': {
    valueName: 'ContactPhone',
    callback(dispatch, values) {
      if (typeof SK !== 'undefined'
        && values.filter(value => value.id === 'ContactPhone').length <= 0
      ) {
        const { phone } = SK.user();
        if (phone && phone.length > 0) {
          dispatch(addValue('ContactPhone', phone, false));
        }
      }
    }
  },
  'set_email': {
    valueName: 'ContactEmail',
    callback(dispatch, values) {
      if (typeof SK !== 'undefined'
        && values.filter(value => value.id === 'ContactEmail').length <= 0
      ) {
        const { email } = SK.user();
        if (email && email.length > 0) {
          dispatch(addValue('ContactEmail', email, false));
        }
      }
    }
  }
};
